const alertDE = {
    delete: {
        account: 'Möchtest du deinen Account und alle zugehörigen Locations unwiderruflich löschen?',
        reminder: 'Willst du diesen Bestellwecker wirklich löschen?',
        location: 'Willst du diese Location wirklich löschen?',
        list: 'Willst du die Liste "{target}" wirklich löschen?',
        noList: 'Willst du alle Produkte aus deinem Warenkorb entfernen?',
        cartSupplier: 'Willst du deinen Warenkorb bei {target} leeren?',
        cartProduct: 'Willst du das Produkt "{target}" wirklich aus dem Warenkorb entfernen?',
        cartList: 'Willst du die Liste "{target}" und alle zugehörigen Artikel wirklich aus dem Warenkorb entfernen?',
        product: 'Willst du das Produkt "{target}" wirklich aus deiner Liste entfernen? | Willst du die selektierten Produkte wirklich aus der Liste entfernen?',
        supplier: 'Willst du {name} aus deinen Lieferanten entfernen? Achtung: Mit dem entfernen eines Lieferanten werden ebenfalls alle Listen bei diesem Lieferanten entfernt.',
        member: 'Willst du wirklich "{target}" aus dem Team entfernen?',
        tag: 'Willst du wirklich "{target}" aus deinen Kategorien entfernen?',
        customSupplier: 'Willst du wirklich diesen Lieferant löschen?',
        scanProduct: "Möchtest du das Produkt \"{target}\" wirklich aus deinen gescannten Artikeln entfernen?"
    },
    delivererSuccess: 'Der Lieferant wurde erfolgreich hinzugefügt',
    delivererError: 'Fehler',
    delivererSuccessMessage: 'Wir haben {target} zu deiner Location hinzugefügt.',
    delivererErrorMessage: '{target} konnte nicht zu deiner Location hinzugefügt werden. Bitte überprüfe deine eingegebenen Daten.',
    selectList: 'Wähle eine Liste',
    selectSupplier: 'Wähle einen Lieferanten',
    noList: 'Keine Liste für diesen Lieferant vorhanden.',
    noSupplier: 'Kein Lieferant für diesen Artikel vorhanden',
    discardFormTitle: 'Achtung!',
    noInternet: 'Es konnten nicht alle Offline-Daten synchronisiert werden. Überprüfe bitte deine Internetverbindung.',
    compatibilityMode: 'Du hast den Kompatibilitätsmodus aktiviert. Während dieser aktiv ist, kannst du nur über das Web-Portal bestellen. Deine angegebene Menge liegt dort nun im Warenkorb vor. Falls du über die App bestellen möchtest, deaktiviere diesen Modus in den Listeneinstellungen.',
    discardForm: 'Ihre angegeben Daten werde nicht gespeichert. Seite trotzdem verlassen?',
    syncing: 'Listen werden synchronisiert',
    logout: 'Wollen Sie sich wirklich abmelden?',
    upgradeToPromotion: 'Jetzt Aktion nutzen? Menge wird automatisch auf Mindestmenge ({target}) angepasst',
    convertToPromotion1: 'Aktion anwenden?',
    convertToPromotion2: '{target1} Aktionsartikel, {target2} regulär',
    orderAmountOverLimit: 'Limit erreicht: {isAmount} Aktionsartikel im Warenkorb. Max. +{availableAmount} möglich',
    scannerNotActivated: 'Die Scanner-Funktion wird derzeit von deinen Lieferanten nicht unterstützt!',
    scannerAvailableOnlyInApp: 'Die Scanner-Funktion ist nur in der App verfügbar!',
    addLastOrderToCart: 'Möchtest du alle Artikel und Mengen deiner letzten Bestellung erneut in den Warenkorb legen?',
}

export default alertDE
